import React, { Suspense, lazy } from "react";
import BannerSection from "./homeSection/bannerSection";
import "../styles/button.css";
import DefaultLoader from "../components/loader";
import Section7 from "./homeSection/section7";
import Section6 from "./homeSection/section6";

const Section1 = lazy(() => import("./homeSection/section1"));
const Section8 = lazy(() => import("./homeSection/section8"));
const Section9 = lazy(() => import("./homeSection/section9"));
const Section2 = lazy(() => import("./homeSection/section2"));
const Section3 = lazy(() => import("./homeSection/section3"));
const ComparisonSection = lazy(() => import("./homeSection/comparisonSection"));
const Section4 = lazy(() => import("./homeSection/section4"));
const Section5 = lazy(() => import("./homeSection/section5"));
const Faqs = lazy(() => import("./homeSection/faqs"));

const Home = ({ isiPhone }) => {
  return (
    <>
      <section className="position-relative">
        <BannerSection isiPhone={isiPhone} />
        <Suspense fallback={<div style={{ minHeight: "100px" }}><DefaultLoader /></div>}>
          <Section2 isiPhone={isiPhone} />
          <Section1 isiPhone={isiPhone} />
          <Section3 isiPhone={isiPhone} />
          <Section8 isiPhone={isiPhone} />
          <Section4 isiPhone={isiPhone} />
          <Section5 isiPhone={isiPhone} />
          <ComparisonSection isiPhone={isiPhone} />
          <Section6 isiPhone={isiPhone} />
          <Section7 isiPhone={isiPhone} />
          <Faqs isiPhone={isiPhone} />
          <Section9 isiPhone={isiPhone} />
        </Suspense>
      </section>
    </>
  );
};

export default Home;
